<template>
    <div class="goods-infor-title">
        <span class="text" v-if="prefixText">
            <img src="@/assets/images/goods/title_pre_left.png" class="icon">
            <span class="font">{{
                    prefixText
            }}</span>
            <img src="@/assets/images/goods/title_pre_right.png" class="icon"></span> {{ title }}
    </div>
</template>

<script>

export default {
    props: {
        title: String,
        prefixText: String
    },

    data() {
        return {
        }
    },
    methods: {}
}
</script>

<style scoped lang="scss">
.goods {
    &-infor {
        &-title {
            font-size: 0.43rem;
            line-height: 0.64rem;
            color: #22242E;
            font-weight: 500;
            margin-bottom: 0.3rem;

            .text {
                font-size: 0;
                line-height: 0;
                margin-right: .2rem;
                display: inline-block;
                transform: translateY(.05rem);

                .font {
                    font-size: 0.37rem;
                    font-weight: 500;
                    color: #666666;
                    opacity: 0.8;
                    transform: translateY(-.07rem);
                    display: inline-block;
                }
            }

            .icon {
                width: 0.11rem;
            }
        }
    }
}
</style>
